<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/recently/shared/recently-viewed/recently-viewed.component.ts
-->
<ng-template #anchor></ng-template>
